import React from "react";

interface DeleteDialogSectionProps {
  icon?: React.ReactElement;
  title?: string;
  children: React.ReactNode;
  borderStyle?: "solid" | "dashed";
  className?: string;
  isActive?: boolean;
  titleAction?: React.ReactNode;
  persistTitleAction?: boolean;
  headerContent?: React.ReactNode;
}

export const DeleteDialogSection: React.FC<DeleteDialogSectionProps> = ({
  icon,
  title,
  children,
  borderStyle = "solid",
  className = "",
  isActive = false,
  titleAction,
  persistTitleAction = false,
  headerContent,
}) => {
  return (
    <div
      className={`group/section border rounded-app flex flex-col  ${
        borderStyle === "dashed" ? "border-dashed" : ""
      } ${className}`}
    >
      <div
        className={`flex items-center gap-2 shrink-0 ${title ? "pb-2" : ""}`}
      >
        <div
          className={`flex items-center *:transition-colors ${
            isActive
              ? "*:text-fg-regular"
              : "*:text-fg-muted-regular *:group-hover/section:text-fg-regular"
          }`}
        >
          {icon}
        </div>
        <span
          className={`transition-colors cursor-default flex-1 ${
            isActive
              ? "text-fg-semibold"
              : "text-fg-muted-semibold group-hover/section:text-fg-semibold"
          }`}
        >
          {title}
        </span>
        {titleAction && (
          <div
            className={`transition-opacity pr-2 ${persistTitleAction ? "opacity-100" : "opacity-0 group-hover/section:opacity-100"}`}
          >
            {titleAction}
          </div>
        )}
      </div>

      {headerContent && <div className="mb-3 shrink-0">{headerContent}</div>}
      <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
        {children}
      </div>
    </div>
  );
};
